import { render } from "./HomeTab.vue?vue&type=template&id=fca061ec"
const script = {}

import "./HomeTab.vue?vue&type=style&index=0&id=fca061ec&lang=scss"

import exportComponent from "/opt/build/repo/sleeper-trader/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__